// Columnas del head por defecto
export const defaultFields = () => {
    return [
        {
            key: 'product',
            label: 'Producto',
            sortable: true
        },
        {
            key: 'number_tank',
            label: 'N.Tanque',
            sortable: true
        },
        {
            key: 'location',
            label: 'Ubicación',
            sortable: true
        },
        {
            key: 'quantity',
            label: 'Cantidad',
            sortable: true
        },
        {
            key: 'unit_of_measure',
            label: 'Und.Volumen',
            sortable: true
        },
        {
            key: 'is_active',
            label: 'Estado',
            sortable: true
        }
    ];
}

// Configuración de la tabla (head, body)
export const dataConfigTable = () => {
    return {
        fields: defaultFields(),
        items: [],
        data: {
            total: 0,
            current_page: 1,
            per_page: 10
        }
    }
}

// Filtros y paginación
export const defaultParamsFilter = () => {
    return {
        // Para paginación
        page: 1,
        per_page: 10,

        // Datos importantes
        product: '',
        company_id: null, // Empresa
        number_tank: '', // Número de tanque
        locations_id: [], // Ubicaciones
        volume_unit_id: [] // Unidades de medida
    };
};

export default {
    loadingDataTable: false,
    loadingDownloadReport: false,
    tableConfig: dataConfigTable(),
    filter: defaultParamsFilter()
}
